import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppWidget from "./WhatsAppWidget";

export const Layout = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <div className="min-h-screen bg-canvas text-white" data-testid="site-layout">
      <Navbar />
      <main className="pt-20">{children}</main>
      <Footer />
      <WhatsAppWidget />
    </div>
  );
};

export default Layout;
